import type { TOC } from '@ember/component/template-only';
import type { EmberChangeset } from 'ember-changeset';
import Dropdown from 'ui-kit/components/changeset/dropdown';
import { array, concat } from '@ember/helper';
import t from 'ember-intl/helpers/t';

interface Signature {
  Args: {
    changeset: EmberChangeset;
  };
}

const ProfessioneStatusDropdownComponent: TOC<Signature> = <template>
  <Dropdown
    @labelName='Statut professionnel ou activité actuelle'
    @propertyName='professionalActivity'
    @allowAdditions={{true}}
    @changeset={{@changeset}}
    as |dropdown|
  >
    {{#each
      (array
        'unemployed'
        'activeFullTime'
        'activePartTime'
        'retired'
        'student'
        'volonteer'
      )
      as |key|
    }}
      <dropdown.Item
        @value={{t (concat 'lifestyle.professional-activity.' key)}}
        @key={{key}}
      />
    {{/each}}
  </Dropdown>
</template>;

export default ProfessioneStatusDropdownComponent;
